<script setup>
defineProps({
  title: String,
  value: String,
  subtitle: String,
  icon: String,
  color: {
    type: String,
    default: "primary",
  },
});
</script>
<template>
  <div class="card border-0 shadow-sm rounded-4 h-100">
    <div class="card-body p-4">
      <div class="d-flex justify-content-between align-items-start">
        <div>
          <div class="text-muted small mb-2">{{ title }}</div>
          <h3 class="fw-bold mb-1">{{ value }}</h3>
        </div>

        <div class="stat-icon" :class="`bg-${color}-subtle text-${color}`">
          <i :class="`bi ${icon}`"></i>
        </div>
      </div>
      <div v-if="subtitle" class="small text-muted">{{ subtitle }}</div>
    </div>
  </div>
</template>

<style scoped>
.stat-icon {
  width: 52px;
  height: 52px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
}
</style>
